import React, { ReactNode } from 'react';
import { getRoute, isActiveRoute } from '../../services/router';
import MainLayout from '../main/MainLayout';
import Wrapper from './styles';

interface Props {
    children: ReactNode;
}

export default function PokerLayout({ children }: Props) {
    const isPokerLobbyPage = isActiveRoute(getRoute('poker'));

    return (
        <Wrapper $isPokerLobbyPage={isPokerLobbyPage}>
            <MainLayout>{children}</MainLayout>
        </Wrapper>
    );
}
